<script lang="ts">
    export let text: string;
</script>

<li class="flex items-start">
    <div class="flex-shrink-0">
        <!-- Heroicon name: check -->
        <svg class="flex-shrink-0 h-6 w-6 text-green-500"
            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round"
                stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
    </div>
    <p class="ml-3 text-base font-medium text-gray-500">
        {text}
    </p>
</li>